export const VALIDATE_LOGGEDIN = 'Authentication/VALIDATE_LOGGEDIN';
export const VALIDATE_LOGGEDIN_SUCCESS = 'Authentication/VALIDATE_LOGGEDIN_SUCCESS';
export const VALIDATE_LOGGEDIN_FAILED = 'Authentication/VALIDATE_LOGGEDIN_FAILED';

export const GET_CURRENT_LANGUAGE = 'Authentication/GET_CURRENT_LANGUAGE';
export const CHANGE_LANGUAGE = 'Authentication/CHANGE_LANGUAGE';

export const LOGOUT = 'Authentication/LOGOUT';
export const LOGOUT_SUCCESS = 'Authentication/LOGOUT_SUCCESS';
export const LOGOUT_FAILED = 'Authentication/LOGOUT_FAILED';

export const CLEAR_VALIDATE_LOGGEDIN_ERROR = 'Authentication/CLEAR_VALIDATE_LOGGEDIN_ERROR';
